import { Routes, RouterModule } from "@angular/router";
import { ModuleWithProviders } from "@angular/core";

import { HomeComponent } from "./home/home.component";
import { CFooterComponent } from "./c-footer/c-footer.component";
import { ContactsComponent } from "./contacts/contacts.component";
import { CalendarComponent } from "./calendar/calendar.component";
import { ResultsComponent } from "./results/results.component";
import { AboutUsComponent } from "./about-us/about-us.component";
import { NewMemberComponent } from "./about-us/new-member/new-member.component";
import { OurServicesComponent } from "./about-us/our-services/our-services.component";
import { RacesComponent } from "./calendar/races/races.component";
// import { R1Component } from './calendar/races/R1/R1.component';
import { VilniusInfoComponent } from "./calendar/races/r1/raceSingle.component";
import { DocumentsComponent } from "./documents/documents.component";
import { MediaComponent } from "./media/media.component";
import { PhotoGalleryComponent } from "./media/photo-gallery/photo-gallery.component";

const APP_Routes: Routes = [
  { path: "", component: HomeComponent },
  { path: "home", component: HomeComponent },
  // {path: 'home', component: HomeComponent},
  { path: "footer", component: CFooterComponent },
  { path: "contacts", component: ContactsComponent },
  { path: "calendar", component: CalendarComponent },
  { path: "results/:id", component: ResultsComponent },
  { path: "about-us", component: AboutUsComponent },
  { path: "about-us", component: AboutUsComponent },
  { path: "newMember", component: NewMemberComponent },
  { path: "ourServices", component: OurServicesComponent },
  { path: "races", component: RacesComponent },
  { path: "races/:id", component: VilniusInfoComponent },
  { path: "documents", component: DocumentsComponent },
  { path: "media", component: MediaComponent },
  { path: "media/:id", component: PhotoGalleryComponent },
  { path: "media/:year/:id", component: PhotoGalleryComponent }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(APP_Routes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts